<template>
	<section class="store-content store-content--select-items">

		<div class="store-content__top clearfix">
			<div class="store-content__top__links store-content__top__links--left">
				<button 
					v-if="backBtnText.length"
					@click="handleBackBtnClick"
					class="btn btn--black store-content__top__btn hard-left"
				>
					<i class="icon icon-chevron-left"></i>
					{{ backBtnText }}
				</button>
			</div>
			<div class="store-content__top__title-container">
				<h2 class="store-content__top__title">
					<i class="icon icon-spoon-and-fork-crossed"></i>
					<span
						v-html="stepTitle"
						class="store-content__top__title__text"
					></span>
				</h2>
			</div>
			<div class="store-content__top__links store-content__top__links--right">

			</div>
		</div>

		<div
			v-if="'category' === active_screen"
			class="store-content__block store-content__block--categories"
		>
			<div class="row">
				<div
					v-for="category in categories"
					:key="category.id"
					class="col-sm-6 col-md-4 category-block-container push-top"
				>
					<CategoryBlock
						:category="category"
						@handle_category_click="handleCategoryClick( category )"
					/>
				</div>
			</div>
		</div>

		<div
			v-else-if="'category-products' === active_screen"
			class="store-content__block store-content__block--products"
		>
			<div 
				v-if="activeCategoryText.length"
				class="row"
			>
				<div class="col-xxs-12">
					<div 
						v-html="activeCategoryText"
						class="active-category-desc push-bottom"
					></div>
				</div>
			</div>

			<div
				v-if="!visibleProducts.length"
				class="row"
			>
				<div class="col-xxs-12">
					<span class="warning">No available products in this category.</span>
				</div>
			</div>
			<div
				v-else
				class="row"
			>
				<div
					v-for="product in visibleProducts"
					:key="product.id"
					class="col-sm-6 col-md-4 product-block-container"
				>
					<ProductBlock
						:product="product"
						@handle_product_click="handleProductClick( product )"
					/>
				</div>
			</div>
		</div>


		<div
			v-else-if="'active-product' === active_screen"
			class="store-content__block store-content__block--product"
		>
			<div
				v-if="null !== active_product"
				class="row"
			>
				<ActiveProduct
					@update_active_product_price="updateActiveProductPrice"
					@populate_cart_items="populateCartItems"
					@finished_updating_cart="$emit( 'finished_updating_cart' )"
					@go_to_select_items="$emit( 'go_to_select_items' )"
					@go_to_cart="$emit( 'go_to_cart' )"
					:product="active_product"
				/>
			</div>

			<div class="row">
				<div class="col-xxs-12 col-sm-6 col-md-8">
					<h3 class="cart-extras__headline">
						<i class="icon icon-plus"></i>
						Add an Extra
					</h3>
					<div class="cart-extras">
						<CartExtra
							v-for="extra in extras"
							:key="extra.id"
							:extra="extra"
							@handle_added_extra="handleAddedExtra"
						/>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>


<script>
	import ActiveProduct from '../components/ActiveProduct.vue'
	import CartExtra from '../components/CartExtra.vue'
	import CategoryBlock from '../components/CategoryBlock.vue'
	import ProductBlock from '../components/ProductBlock.vue'


	export default {
		name: 'StepSelectItems',
		components: {
			ActiveProduct,
			CartExtra,
			CategoryBlock,
			ProductBlock,
		},


		props: {
			categories: {
				type: Object,
				required: true,
			},
			active_product: {
				type: Object,
				default: null
			},
			active_screen: {
				type: String,
				default: 'category'
			},
			extras: {
				type: Object,
				default() {
					return []
				}
			}
		},


		data() {
			return {
				stepTitle: 			'New Items',
				visibleProducts:	[],
				backBtnText: 		'',
				activeCategory: 	null,
				activeCategoryText: '',
			}
		},


		beforeMount() {
			let activeProductTitle = this.getTitleFromActiveProduct()

			if( 'string' !== typeof activeProductTitle || !activeProductTitle.length ) {
				activeProductTitle = 'New Items'
			}

			this.stepTitle = activeProductTitle
		},


		methods: {
			handleCategoryClick( category ) {
				this.visibleProducts 	= category.products
				this.stepTitle 			= category.title

				this.activeCategory 	= category.title
				this.activeCategoryText = category.description
				this.backBtnText 		= 'All Categories'

				this.setActiveScreen( 'category-products' )
			},


			handleProductClick( product ) {
				if( undefined === product.quantity ) {
					product.quantity = 1
				}

				// set active product based on the user-selected product
				this.$emit( 'set_active_product', product )

				this.$nextTick( () => {
					this.stepTitle = this.getTitleFromActiveProduct()
					this.backBtnText = `All ${this.activeCategory}`

					this.setActiveScreen( 'active-product' )
				})
			},


			getTitleFromActiveProduct() {
				if( null !== this.active_product ) {
					return `${this.active_product.title} - ${this.active_product.price_pretty}`
				}
			},


			updateActiveProductPrice() {
				this.stepTitle = this.getTitleFromActiveProduct()
			},


			populateCartItems( cartItems ) {
				this.$emit( 'populate_cart_items', cartItems, true )
			},


			handleAddedExtra( cartItems ) {
				this.$emit( 'populate_cart_items', cartItems )
			},			


			setActiveScreen( screen ) {
				this.$emit( 'set_active_screen', screen )
			},


			handleBackBtnClick() {
				if( 'category-products' === this.active_screen ) {
					this.backBtnText = ''
					this.setActiveScreen( 'category' )
				} else if( 'active-product' === this.active_screen ) {
					this.backBtnText = 'All Categories'
					this.setActiveScreen( 'category-products' )
				}
			},
		
		},


		beforeUpdate() {
			if( 'category' === this.active_screen ) {
				this.stepTitle = 'Select Items'
			}
		},

	}
</script>